import styled from "styled-components"

export const StyledFullPageLoader = styled.div`
background-color: white;
width: 100%;
height: 100%;
position: fixed;
top: 0;
left: 0;
display: flex;
justify-content: center;
align-items: center;
background-color: white;
opacity:0.5;

`
export default StyledFullPageLoader